<template>
    <div class="reservation-promo">
        <h2 class="reservation-promo__heading">Reserveringen</h2>
        <div class="reservation-promo__card">
            <div class="reservation-promo__title-row">
                <svg class="reservation-promo__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h9v-2H5V10h14v1h2V6c0-1.1-.9-2-2-2zM5 8V6h14v2H5z" fill="#033239"/>
                    <path d="M21.25 18.5L17.5 14.75v2.75H13v2h4.5v2.75z" fill="#033239"/>
                </svg>
                <h3 class="reservation-promo__title">Maak een reservering</h3>
            </div>
            <p class="reservation-promo__text">
                Reserveer makkelijk en snel een auto of bus. Wij hebben een wagenpark vol jonge en frisse auto's.
            </p>
            <div class="reservation-promo__cta-wrapper">
                <a :href="newReservationUrl" class="reservation-promo__button">
                    <span>Maak een reservering</span>
                    <svg class="reservation-promo__chevron" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                        <path d="M5.25 3.5L8.75 7L5.25 10.5" stroke="#033239" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReservationPromo',

    props: {
        newReservationUrl: {
            type: String,
            default: '/aanbod'
        }
    }
}
</script>

<style scoped>
.reservation-promo {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
}

.reservation-promo__heading {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 24px;
    line-height: normal;
    color: #033239;
    margin: 0;
}

.reservation-promo__card {
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0 8px 5px rgba(0, 125, 147, 0.13);
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: stretch;
}

.reservation-promo__title-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.reservation-promo__icon {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
}

.reservation-promo__title {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    color: #033239;
    margin: 0;
}

.reservation-promo__text {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #033239;
    margin: 0;
    max-width: 534px;
}

.reservation-promo__cta-wrapper {
    display: flex;
    justify-content: flex-end;
}

.reservation-promo__button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #82db39;
    border: 1px solid #82db39;
    color: #033239;
    padding: 16px 24px;
    border-radius: 4px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    text-decoration: none;
    transition: background-color 0.15s ease, border-color 0.15s ease;
}

.reservation-promo__button:hover,
.reservation-promo__button:focus {
    background: #70c72e;
    border-color: #70c72e;
    color: #033239;
    text-decoration: none;
}

.reservation-promo__chevron {
    flex-shrink: 0;
}

@media (max-width: 575px) {
    .reservation-promo__card {
        padding: 24px;
    }
    .reservation-promo__cta-wrapper {
        justify-content: stretch;
    }
    .reservation-promo__button {
        width: 100%;
        justify-content: center;
    }
}
</style>
